import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "./index.css";
import { Pase } from "@panel/Pase.tsx";
import { CONTENEDOR, mapaDeTemas, temaDeHostname } from "./tema";
import { puerto } from "./puerto";

/**
 * TAP — el pase del colaborador. El arranque.
 *
 * ═══════════════════════════════════════════════════════════════════════════
 * EL TEMA SE PONE EN `<html>` Y EN `<body>`, NO EN UN `<div>`
 * ═══════════════════════════════════════════════════════════════════════════
 * `.panem-ui` trae el `background` del tema. Puesto solo en el contenedor de
 * React, el fondo llega hasta donde llega el contenido: al hacer scroll de
 * rebote en iOS, o en una pantalla más alta que el pase, aparece el blanco del
 * navegador por debajo. En un cuarto a 5 lux eso es una linterna.
 *
 * ═══════════════════════════════════════════════════════════════════════════
 * EL TEMA SE RESUELVE POR HOSTNAME
 * ═══════════════════════════════════════════════════════════════════════════
 * Ver `tema.ts`. El mapa lo inyecta el despliegue; el respaldo es el tema del
 * venue para el que se construyó este bundle. Un hostname desconocido NO deja
 * la pantalla sin vestir.
 */
const tema = temaDeHostname(
  location.hostname,
  mapaDeTemas(import.meta.env["VITE_TEMAS"] as string | undefined),
  CONTENEDOR,
);

document.documentElement.classList.add(tema);
document.body.classList.add(tema);

const root = document.getElementById("root");
if (!root) {
  throw new Error("TAP pase: falta #root en index.html");
}

createRoot(root).render(
  <StrictMode>
    <Pase
      puerto={puerto}
      urlInicial={location.href}
      alLimpiarUrl={() => {
        // `replaceState` y no `location.href = …`: cambiar la dirección
        // recargaría la app y tiraría la sesión que se acaba de abrir en
        // memoria. Esto reescribe la barra de direcciones sin navegar.
        //
        // Se quitan el query Y el fragmento: la liga puede venir por cualquiera
        // de los dos (`ligaDeLaUrl` acepta ambos), y limpiar solo uno deja el
        // token en el historial por el otro.
        history.replaceState(null, "", location.pathname);
      }}
    />
  </StrictMode>,
);

// La API nunca se cachea. Solo permite reabrir la pantalla y leer el QR
// estático previamente guardado, hasta su caducidad.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  void navigator.serviceWorker.register(`${import.meta.env.BASE_URL}sw.js`, { scope: import.meta.env.BASE_URL }).catch(() => {});
}
